import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RenewalStatusForm from '../../../components/forms/RenewalStatusForm';
import { useRenewalStatusApi } from '../../../hooks/useRenewalStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { RenewalStatusDTO } from '../../../services/apiClient';

const RenewalStatusCreate: React.FC = () => {
  const { create, isLoading } = useRenewalStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Renewal Statuses', href: '/admin/renewalstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RenewalStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/renewalstatuses');
    } catch (error) {
      console.error('Error creating RenewalStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/renewalstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RenewalStatus.Edit"
    >
        <RenewalStatusForm
          initialValues={{} as RenewalStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/renewalstatuses')}
        />
    </AdminLayout>
  );
};

export default RenewalStatusCreate;
